export function stringToArray(value: string, separator: string): string[] {
  return value
    .split(separator) // convert to array by separator
    .map((str) => str.trim()) // trim all values
    .filter((str) => !!str); // remove empty strings
}
